<template>
    <setup_content title="Подбор объектов-аналогов для расчета ставки капитализации методом рыночной экстракции (на основе группы пар данных)">

		<!--
        <template v-slot:buttons>
            <div v-if="check_roles([ 'model' ])" class="d-flex justify-content-center mb-2" style="gap: .625rem;">
                <b-button variant="outline-primary-secondary" v-on:click="set_analogues">
                    <span>Подобрать объекты-аналоги</span><base-icon name="checkbox_chek" size="md" />
                </b-button>
            </div>
		</template>
		-->

		<h4 v-if="calculated_value !== null">Рассчитанное значение cтавки капитализации для оценочной подгруппы: {{ calculated_value }}</h4>

		<b-row class="mt-2">

			<b-col cols="9">

				<h4>Распределение ставок капитализации по порядковому номеру объекта-аналога</h4>

				<scatter_plot ref="scatter_plot" :group_id="group_id"
					title="Распределение ставок капитализации по порядковому номеру объекта-аналога"
					bad_attr_key="bad_capitalization_rate" :query="plot_query"
					with_zoom with_line with_area with_x_axis_title
					x_attr_key="index" y_attr_key="attrs.capitalization_rate" sort_by="current_version.attrs.capitalization_rate"
					v-on:need_refresh="() => refresh(false)"
					v-on:toggle_objects="set_not_excluded_from_plot"
					@get_plot_data="(data) => y_avg(data)"
				/>

			</b-col>
			<b-col>

				<stat_capital ref="stat_capital" :group_id="group_id" />

			</b-col>

		</b-row>

		<elements
			v-if="group_id"
			ref="objects"
			:service="service"
			:postfix_for_storage_name="'capitalization_pair_groups' + id"
			without_add
			:attrs="attrs"
			:raw_query="{ group : group_id }"
			:additional_query="additional_query"
			not_able_for_delete
			with_filters
			essence_name_genetive_case="объекта-аналога"
			essence_name_for_plural_1="объект-аналог"
			essence_name_for_plural_234="объекта-аналога"
			essence_name_for_plural_others="объектов-аналогов"
			without_back_button
			initial_per_page="5"
			initial_sort_by="current_version.attrs.CadastralNumber"
			:initial_sort_desc="false"
			elements_table_height="25vh"
		>

			<template v-slot:title>

				<h4>Объекты-аналоги</h4>

			</template>

			<template v-slot:nav_items>

				<b-button v-if="check_roles([ 'model' ])" v-b-tooltip:fullscreen.hover.bottomright variant="outline-primary" title="Исключить объекты-аналоги из расчета" v-on:click="exclude_many">

					<base-icon name="delete" />

				</b-button>

			</template>

			<template v-slot:table_cell_params="cell">

				<span v-if="cell.data.field.key == 'current_version.attrs.bad_capitalization_rate'">

					<b-form-checkbox v-if="cell.data.field.key == 'current_version.attrs.bad_capitalization_rate'" :disabled="!check_roles([ 'model' ])" :checked="! cell.data.item.current_version.attrs.bad_capitalization_rate" v-on:input="value => set_not_excluded(cell.data.item.current_version.attrs.CadastralNumber, value)"/>
				
				</span>

			</template>

		</elements>

    </setup_content>
</template>

<script>

import api from "../../../../../../api"
import setup_content from '../../setup_assets/content'
import stat_capital from './stat_capital'
import scatter_plot from "../scatter_plot"
import elements from '../../../../../elements'

export default {

    props :
    {
        data : Object,
        id : String,
        group_id : String,
    },

    components :
    {
        setup_content,
		scatter_plot,
        stat_capital,
        elements,
    },

    data()
    {
        return {

			service : "cadastral_analogues",
			additional_query : { "current_version.attrs.CadastralNumber" : { "$exists" : true }, "system.has_connection_to_another_analogue" : true },

			calculated_value : null,
        }
    },

	computed:
	{
		plot_query()
		{
			return {
				"$and" :
				[
					this.additional_query,
					{
						"current_version.attrs.analogue_profitable_type": "Аренда"
					}
				]
			}
		},

		attrs()
		{
			const attrs = [
				{
					attr_key : "attrs.bad_capitalization_rate",
					label : "Учитывать при подборе",
					visible : true,
					visible_if_no_visible : true,
					bool_reverse : true,
					params : true,
				},
				{
					attr_key : "attrs.CadastralNumber",
					label : "Кадастровый номер",
					visible : true,
					visible_if_no_visible : true,
				},
				{
					attr_key : "attrs.group_code",
					visible : true,
					visible_if_no_visible : true,
				},
				{
					attr_key : "attrs.capitalization_rate",
					visible : true,
					visible_if_no_visible : true,
				},
				{
					attr_key : "attrs.analogue_profitable_type",
					visible : true,
					visible_if_no_visible : true,
				},
				{
					attr_key : "attrs.period",
					visible : true,
					visible_if_no_visible : true,
				},
				{
					attr_key : "attrs.area_profitable",
					visible : false,
				},
				{
					attr_key : "attrs.corrected_price",
					visible : false,
				},
				{
					attr_key : "attrs.uprs",
					visible : true,
					visible_if_no_visible : true,
				},
			]

			if (api.has_oks())
			{
				attrs.push(
					{
						attr_key : "attrs.beds",
						visible : false,
					})
				attrs.push(
					{
						attr_key : "attrs.dimension",
						visible : false,
					}
				)
			}

			return attrs
		}
	},

    methods :
    {
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		refresh(with_scatter_plot = true, with_objects = true)
		{
			if(with_objects && this.$refs.objects)
				this.$refs.objects.refresh()

			if(with_scatter_plot && this.$refs.scatter_plot)
				this.$refs.scatter_plot.refresh()

			if(this.$refs.stat_capital)
				this.$refs.stat_capital.refresh()
		},

        set_analogues()
        {
			if (this.check_roles([ 'model' ]))
            {
				api.call_long_operation(this, "Подбор объектов-аналогов", "cadastral_cost_evaluation", "evaluate_capitalization_rate", { id : this.id },
					response =>
					{
						api.open_response_url(response)
	
						this.refresh()
					})
			}
        },

		set_not_excluded(cadastral_number, value)
		{
			if (this.check_roles([ 'model' ]))
            {
				api.call(this, "cadastral_cost_evaluation", "set_bad_capitalization_rate_for_pair", { id : this.id, query : { "current_version.attrs.CadastralNumber" : cadastral_number }, value : ! value }, () => this.refresh())
			}
		},

		set_not_excluded_from_plot(ev)
		{
			if (this.check_roles([ 'model' ]))
			{
				var promises = []

				ev.objects.forEach(
					obj =>
					{
						const cadastral_number = obj["attrs.CadastralNumber"]

						promises.push(api.call(this, "cadastral_cost_evaluation", "set_bad_capitalization_rate_for_pair", { id : this.id, query : { "current_version.attrs.CadastralNumber" : cadastral_number }, value : ! ev.state }, () => {}))
					})

				Promise.all(promises).then(() => this.refresh())
			}
		},

		exclude_many()
		{
			if (this.check_roles([ 'model' ]))
            {
				const query = this.$refs.objects.get_query()
	
				api.call(this, "cadastral_cost_evaluation", "set_bad_capitalization_rate_for_pair", { id : this.id, query : query, value : true }, () => this.refresh())
			}
		},

		y_avg(data) {
			if (data)
			{
				const filtered_data = data.filter((obj) => obj.bad === false && obj.y !== undefined)
	
				if (filtered_data.length !== 0)
				{
					const calculated = filtered_data.reduce((sum, {y}) => sum + y, 0) / filtered_data.length
					this.calculated_value = api.roundToStr(calculated, 4)
				}
				else
				{
					this.calculated_value = null
				}
			}
		}
	},
}
</script>
